import React from 'react';
import { IconProps } from './icons.models';

const WarningIcon: React.FC<IconProps> = ({
    width = 14,
    height = 13,
    className,
    onClick,
    fillColor = '#BA1A1A',
}) => {
    return (
        <svg width={width} height={height} className={className} onClick={onClick} viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.91683 8.95668H6.92249M6.91683 4.70668V6.83168M5.90745 1.31873L0.908035 9.66502C0.805029 9.84354 0.750546 10.0459 0.750004 10.252C0.749462 10.4581 0.80288 10.6608 0.904947 10.8399C1.00701 11.0189 1.15417 11.1682 1.33179 11.2727C1.50942 11.3773 1.71131 11.4335 1.91741 11.4358H11.9162C12.1224 11.4337 12.3245 11.3776 12.5022 11.2731C12.6799 11.1686 12.8272 11.0193 12.9293 10.8402C13.0314 10.6611 13.0848 10.4583 13.0842 10.2521C13.0835 10.0459 13.0288 9.84351 12.9256 9.66502L7.92691 1.31873C7.82177 1.14513 7.67364 1.00159 7.49682 0.901966C7.32001 0.802341 7.12049 0.75 6.91754 0.75C6.71459 0.75 6.51507 0.802341 6.33825 0.901966C6.16144 1.00159 6.0133 1.14513 5.90816 1.31873" stroke={fillColor} strokeWidth="1.5" strokeMiterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default WarningIcon;


